import { createFileRoute } from '@tanstack/react-router'
import type { PlannerSearch } from '@/components/planner/planner-page'
import { PlannerRoutePage } from '@/components/planner/planner-route-page'

export const Route = createFileRoute('/planner/$versionId')({
  validateSearch: (search: Record<string, unknown>): PlannerSearch => ({
    kind: search.kind === 'hotel' || search.kind === 'flight' ? search.kind : undefined,
    module: typeof search.module === 'string' ? search.module : undefined,
  }),
  component: PlannerRoutePage,
})
